import LiveChat from './code/Scripts/components/LiveChat/LiveChat.vue';

export default {
  components: {
    LiveChat,
  },
};
